export default __webpack_public_path__ + "static/media/looking.cab84e46.png";